// import request from '@/plugin/axios'
//
// export function AccountLogin (data) {
//   return request({
//     url: '/UserLogin.do',
//     method: 'post',
//     data
//   })
// }
//
import {post} from "@/plugin/newAxios";
export const AccountLogin = params => post('/auth/v1/mkt/login',params)

//忘记密码
export const forgetPasswordApi = params => post('/khfw/v1/info/forget-password',params)
